import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';

const routes: Routes = [
  // {
  //   path: 'home',
  //   loadChildren: () => import('./pages/home/home.module').then(m => m.HomePageModule)
  // },
  {
    path: 'main',
    loadChildren: () => import('./pages/main/main.module').then(m => m.MainPageModule)
  },
  // {
  //   path: 'message/:id',
  //   loadChildren: () => import('./pages/view-message/view-message.module').then(m => m.ViewMessagePageModule)
  // },
  {
    path: 'list/:id',
    loadChildren: () => import('./pages/view-list/view-list.module').then(m => m.ViewListPageModule)
  },
  {
    path: 'add-list',
    loadChildren: () => import('./pages/edit-list/edit-list.module').then(m => m.EditListPageModule)
  },
  {
    path: 'edit-list/:id',
    loadChildren: () => import('./pages/edit-list/edit-list.module').then(m => m.EditListPageModule)
  },
  {
    path: '',
    redirectTo: 'main',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
